import React, { useMemo } from 'react'
import { PERMISSIONS } from '../../auth/constants'
import { PREFERENCES } from '../../user/constants'

import { useUserPreferencesFetch, useUserPreference } from '../../user/hooks'
import {
  useRoadClosuresFetch,
  useAgenciesFetch,
} from '../../roadClosures/hooks'
import { usePermissions } from '../../auth/hooks'

import BaseLayout from '../../common/components/BaseLayout'

import HiddenTab from '../../tabs/components/HiddenTab'
import Tab from '../../tabs/components/Tab'
import TabMenu from '../../tabs/components/TabMenu'
import TabPanel from '../../tabs/components/TabPanel'
import TabPanelContainer from '../../tabs/components/TabPanelContainer'

import UserPanel from '../../user/components/UserPanel'
import SearchPanel from '../../search/components/SearchPanel'
import ClosuresPanel from '../../roadClosures/components/ClosuresPanel'
import AddClosureForm from '../../roadClosures/components/AddClosureForm'
import EditClosureForm from '../../roadClosures/components/EditClosureForm'

import Map from '../../map/components/Map'
import Zoom from '../../map/components/Zoom'
import BasemapToggle from '../../map/components/BasemapToggle'
import Compass from '../../map/components/Compass'
import RoadClosuresLayer from '../../map/components/RoadClosuresLayer'
import RoadClosuresEditLayer from '../../map/components/RoadClosuresEditLayer'
import RoadsLayer from '../../map/components/RoadsLayer'
import AddressSearchLayer from '../../map/components/AddressSearchLayer'

import styles from './MainLayout.module.css'

const MainLayout = () => {
  useUserPreferencesFetch() // fetch user's preferences
  useRoadClosuresFetch()
  useAgenciesFetch()

  const [canEdit] = usePermissions([PERMISSIONS.ROAD_CLOSURES_EDIT])

  const basemap = useUserPreference(PREFERENCES.DEFAULT_BASEMAP) || 'streets-vector'

  const mapPadding = useMemo(
    () => ({
      top: 60,
      left: 460,
      right: 10,
      bottom: 20,
    }),
    []
  )

  return (
    <BaseLayout title="Road Closures">
      <div className={styles.tabBar}>
        <TabMenu>
          <Tab path="/roadClosures/userMenu" icon="fa fa-user" />
          <Tab
            path="/roadClosures/closureList"
            defaultPath="/roadClosures"
            icon="fa fa-list-ul"
          />
          <Tab path="/roadClosures/search" icon="fa fa-search" />
          {canEdit && (
            <Tab path="/roadClosures/addClosure" icon="fas fa-plus" />
          )}
          {canEdit && (
            <HiddenTab
              path="/roadClosures/editClosure"
              icon="fas fa-pencil-alt"
            />
          )}
        </TabMenu>
      </div>
      <div className={styles.sideBar}>
        <TabPanelContainer>
          <TabPanel path="/roadClosures/userMenu">
            <UserPanel />
          </TabPanel>
          <TabPanel path="/roadClosures/closureList">
            <ClosuresPanel />
          </TabPanel>
          <TabPanel path="/roadClosures/search">
            <SearchPanel />
          </TabPanel>
          {canEdit && (
            <TabPanel path="/roadClosures/addClosure">
              <AddClosureForm />
            </TabPanel>
          )}
          {canEdit && (
            <TabPanel path="/roadClosures/editClosure">
              <EditClosureForm />
            </TabPanel>
          )}
          <TabPanel>
            <ClosuresPanel />
          </TabPanel>
        </TabPanelContainer>
      </div>
      <Map basemap={basemap} padding={mapPadding}>
        <BasemapToggle
          position="top-right"
          next={basemap === 'streets-vector' ? 'satellite' : 'streets-vector'}
        />
        <Compass position="bottom-right" />
        <Zoom position="bottom-right" />
        <RoadsLayer />
        <RoadClosuresLayer />
        <RoadClosuresEditLayer />
        <AddressSearchLayer />
      </Map>
    </BaseLayout>
  )
}

export default MainLayout
